import React, { useState } from 'react';
import { auth } from '../firebaseConfig';
import './RateLimitBypassModal.css';

// ✅ Get API base URL (same logic as api.js)
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 
  (window.location.hostname === 'localhost' 
    ? 'http://localhost:8080/api' 
    : 'https://ops-console.nezo-app.com/api');

function RateLimitBypassModal({ show, onSuccess, onCancel }) {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  if (!show) return null;

  const handleBypass = async () => {
    if (!password.trim()) {
      setError('Please enter your password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const firebaseUser = auth.currentUser;
      
      if (!firebaseUser) {
        throw new Error('Not authenticated - please log in again');
      }

      console.log('🔐 Getting Firebase token for:', firebaseUser.email);

      const token = await firebaseUser.getIdToken(true);
      console.log('✅ Got Firebase token for bypass');

      const bypassUrl = `${API_BASE_URL}/admin/bypass-rate-limit`;
      console.log('📡 Calling bypass endpoint:', bypassUrl);

      const response = await fetch(bypassUrl, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ password })
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to bypass rate limit');
      }

      sessionStorage.setItem('rateLimitBypass', data.bypassToken);
      console.log('✅ Bypass token stored - valid for 30 minutes');

      setPassword('');
      setSuccess(true);
      setTimeout(() => {
        window.location.reload(); // ← Force reload so all requests retry with token
      }, 1500);

    } catch (err) {
      console.error('❌ Bypass error:', err);
      setError(err.message || 'Failed to authenticate. Please check your password.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && !loading) {
      handleBypass();
    }
  };

  return (
    <div className="rl-bypass-overlay">
      <div className="rl-bypass-container">
        <h2 className="rl-bypass-title">⏱️ Rate Limit Reached</h2>
        <p className="rl-bypass-description">
          You've hit the rate limit. As an admin, you can bypass this for 30 minutes.
        </p>
        
        <div className="rl-bypass-form">
          <label htmlFor="rl-admin-password" className="rl-bypass-label">
            Enter your password:
          </label>
          <input
            id="rl-admin-password"
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Your Firebase password"
            disabled={loading}
            className="rl-bypass-input"
            autoFocus
          />
          
          {error && <div className="rl-bypass-error">❌ {error}</div>}

          {success && <div className="rl-bypass-success">✅ Bypass granted! Resuming...</div>}
          
          <div className="rl-bypass-actions">
            <button 
              onClick={handleBypass} 
              disabled={loading}
              className="rl-bypass-btn rl-bypass-btn-primary"
            >
              {loading ? '⏳ Verifying...' : '✅ Continue'}
            </button>
            <button 
              onClick={onCancel} 
              disabled={loading}
              className="rl-bypass-btn rl-bypass-btn-secondary"
            >
              Cancel
            </button>
          </div>
          
          <small className="rl-bypass-note">
            ℹ️ Bypass token is valid for 30 minutes
          </small>
        </div>
      </div>
    </div>
  );
}

export default RateLimitBypassModal;
